import React, { Fragment } from 'react'
import withStyles from '@mui/styles/withStyles';
import { Paper, Grid, Typography } from '@mui/material'

const styles = theme => ({
    grid: {
        margin: '1rem',
    },
    paper: {
        width: 600,
        height: 200
    }
})

const Contracts = ({ classes }) => {
    return (
        <Fragment>
            <Typography variant="h5">Contracts</Typography>
            <Grid container spacing={8} className={classes.grid}>
                <Grid item>
                    <Paper elevation={1} className={classes.paper}>

                    </Paper>
                </Grid>
            </Grid>
        </Fragment>
    )
}

export default withStyles(styles)(Contracts)
